import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useResizeDetector } from 'react-resize-detector';
import { styled } from 'styled-components';

import Column from 'components/common/Column';
import Row from 'components/common/Row';
import NoticeCard from 'containers/Notice/components/NoticeCard';
import { useNoticeDetailHooks } from './hooks/useNoticeDetailHooks';
import CommonImage from 'components/common/CommonImage';
import { ICON_NAVIGATE_BACK } from 'assets/icons';
import { MAX_WIDTH } from 'App';
import WrapperContainer from 'components/common/Wrapper';

const Container = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${props => (props.$isMobile ? '24px 0' : '24px 0 40px')};
  width: 100%;
  max-width: 768px;
  min-height: 100vh;
  background-color: #fff;
`;

const HtmlContainer = styled.div`
  width: 100%;

  img {
    width: 100%;
  }
`;

const NoticeDetailPage = () => {
  const { noticeBoard } = useNoticeDetailHooks();

  const navigate = useNavigate();

  const { width, ref } = useResizeDetector();

  const isMobile = width ? width <= MAX_WIDTH : window.innerWidth <= MAX_WIDTH;

  return (
    <WrapperContainer isMobile={isMobile}>
      <Container $isMobile={isMobile} ref={ref}>
        {noticeBoard && (
          <React.Fragment>
            <Column
              gap="16px"
              style={{
                padding: isMobile ? '0 20px 40px' : '0 40px 40px',
              }}
            >
              <Row gap="16px" style={{ width: '100%' }}>
                <CommonImage
                  src={ICON_NAVIGATE_BACK}
                  onClick={() => {
                    navigate(-1);
                  }}
                />
                {noticeBoard.board.notices.edges.map((item, idx) => {
                  return <NoticeCard item={item} type="detail" key={idx} />;
                })}
              </Row>
            </Column>
            <Column
              align="flex-start"
              style={{ padding: isMobile ? '0 20px 40px' : '0 40px 40px' }}
            >
              <HtmlContainer
                dangerouslySetInnerHTML={{
                  __html: noticeBoard.board.notices.edges[0].node.content,
                }}
                style={{ width: '100%' }}
              />
            </Column>
          </React.Fragment>
        )}
      </Container>
    </WrapperContainer>
  );
};

export default NoticeDetailPage;
